import { route } from '../constants/routePath';
import AxiosRequest from '../configs/api';

const LeadService = {};

LeadService.createLead = (payload) => AxiosRequest.post(
    `/${route.leads}/api/v1/leads/createNew`,
    payload,
  )

LeadService.assignToList = (token) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/assignees?`,
    token
  )

LeadService.getCityStatebyPin = (pin) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/cities/${pin}`
  )

LeadService.getLeads = (token) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/fetch`,
    token
  )

LeadService.getProducts = () => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/products`
  )
  LeadService.getProductsByBrand = (brandId) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/products/${brandId}`
  )
LeadService.getConstructionDetails = (brandId) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/lead_param_values/${brandId}?`,
  )

LeadService.getLeadsTSE = (query) => AxiosRequest.get(
    `/${route.leads}/api/v1/leads/assigned?internal_status=${query}`,
  )

LeadService.acceptRejectLead = (payload) => AxiosRequest.post(
    `/${route.leads}/api/v1/leads/accept-reject`,
    payload,
  )

export default LeadService;